import { Colors } from '../../../models/disciplines';
import { getTimeAgo } from '../../../utils/dataTools';
import { getDisciplineName } from '../../../utils/discipline';
import { Tag } from '../../atoms/Tag';
import InnerHTMLContainer from '../InnerHTMLContainer';
import { Typography } from '../Typography';

interface NotificationProps {
  text: string;
  disciplineSlug: string;
  displayDate: string;
  toContentNavigate: () => any;
}

const Notification = ({
  text,
  disciplineSlug,
  displayDate,
  toContentNavigate,
}: NotificationProps) => {
  const slug =
    disciplineSlug === 'interdisciplinares'
      ? 'interdisciplinar'
      : disciplineSlug;

  return (
    <div
      className='flex w-[467px] max-w-[100%] cursor-pointer flex-col gap-sm rounded-sm bg-color-lightest p-4'
      onClick={toContentNavigate}
    >
      <Typography>
        <InnerHTMLContainer data={text} />
      </Typography>
      <div className='flex items-center gap-sm'>
        <Tag variant={slug as Colors} className='w-fit py-1 text-xs'>
          {getDisciplineName(slug)}
        </Tag>
        <Typography size='small'>
          {getTimeAgo(new Date(displayDate))}
        </Typography>
      </div>
    </div>
  );
};

export default Notification;
